import { render, staticRenderFns } from "./EditDepartmentRule.vue?vue&type=template&id=85ed8ed6"
import script from "./EditDepartmentRule.vue?vue&type=script&lang=js"
export * from "./EditDepartmentRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports